import { useState, useRef, useEffect, useReducer } from "react";
import BlogCard from "./BlogCard";
import "../index.css";
import { db } from "../firebaseinit";
import { collection, addDoc, doc, onSnapshot, deleteDoc } from "firebase/firestore";

function blogsReducer(state, action) {
  switch (action.type) {
    case "ADD":
      return [action.blog, ...state];

    case "REMOVE":
      return state.filter((blog) => blog.id !== action.id);

    case "SET":
      return action.blogs;

    default:
      return state;
  }
}

export default function Blog() {
  const [formData, setFormData] = useState({ title: "", content: "" });
  const [blogs, dispatch] = useReducer(blogsReducer, []);
  const titleRef = useRef(null);

  useEffect(() => {
    titleRef.current.focus();
  }, []);

  useEffect(() => {
    if (blogs.length === 0) {
      document.title = "No blogs here";
    } else {
      document.title = blogs[0].title || "Untitled Blog";
    }
  }, [blogs]);
  

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "blogs"), (snapShot) => {
      const fetchedBlogs = snapShot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      dispatch({ type: "SET", blogs: fetchedBlogs });
    });

    return () => unsub(); // cleanup
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    titleRef.current.focus();

    await addDoc(collection(db, "blogs"), {
      title: formData.title,
      content: formData.content,
      createdOn: new Date()
    });

    setFormData({ title: "", content: "" });
  }

  async function removeBlog(idToRemove) {
    const docRef = doc(db, "blogs", idToRemove);
    await deleteDoc(docRef);
  }

  return (
    <>
      <h1>Write a Blog!</h1>

      <div className="section">
        <form onSubmit={handleSubmit}>
          <Row label="Title">
            <input
              className="input"
              placeholder="Enter the Title of the Blog here.."
              value={formData.title}
              ref={titleRef}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            />
          </Row>
          <Row label="Content">
            <textarea
              className="input content"
              placeholder="Content of the Blog goes here.."
              value={formData.content}
              required
              onChange={(e) => setFormData({ ...formData, content: e.target.value })}
            />
          </Row>

          <button className="btn" type="submit">
            ADD
          </button>
        </form>
      </div>

      <hr />

      <h2>Blogs</h2>
      {blogs.map((formData) => (
        <div className="blog" key={formData.id}>
          <BlogCard data={formData} removeBlog={removeBlog} />
        </div>
      ))}
    </>
  );
}

function Row({ label, children }) {
  return (
    <>
      <label>
        {label}
        <br />
      </label>
      {children}
      <hr />
    </>
  );
}
